import { render, staticRenderFns } from "./rewardBag.vue?vue&type=template&id=24d2a156&"
import script from "./rewardBag.vue?vue&type=script&lang=js&"
export * from "./rewardBag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports